import { accountsEnvironment } from '../accounts-environment';
import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { userSchema } from '../schemas/user.schema';
import { dataAccessEnvironment } from '../../../models/data-access-environment';
import { AuthHeaders } from '../../../models/auth-headers';
import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

const requestSchema = z.array(
  userSchema
    .omit({
      id: true,
      assignments: true,
    })
    .partial()
    .required({
      externalId: true,
    })
);

/**
 * @deprecated This endpoint's behavior is not consistent with other similar endpoints. Please use postAmsuiUsersImport instead
 *
 * Create multiple Users
 * @param request An array of Users to create (only externalId is required for each User)
 * @returns A data object indicating success
 */
export function postUsersImport(
  this: unknown,
  request: z.infer<typeof requestSchema>
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(`${accountsEnvironment.resolve(this).usersUrl}/import`, {
        method: 'POST',
        headers: {
          ...requiredHeaders,
          ...(dataAccessEnvironment.configuration.useLegacyTokenForAccountsApi
            ? new AuthHeaders()
            : jwtAuthHeaders),
        },
        body: JSON.stringify(request),
      })
    )
  ).pipe(
    selectData(
      z.object({
        data: z.string(),
        duplicateExternalIdsInPartner: z.array(z.string()).optional(),
      })
    )
  );
}
